import { render } from "./ScrollDownMouse.vue?vue&type=template&id=4899c704&scoped=true"
const script = {}

import "./ScrollDownMouse.vue?vue&type=style&index=0&id=4899c704&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4899c704"]])

export default __exports__